module.exports = __webpack_public_path__ + "img/avatar-valo-motion.e8450f61.png";